export const MOCK_WALLET_DATA = {
  user: { address: '0xMockUserAddress000000000000000000000000', ens: 'mock.eth', balance: '2.4', network: 'Polygon' }
};

export const MOCK_ACHIEVEMENTS = {
  unlocked: [],
  readyToMint: [ { id: 4, name: 'Mobile Banking Pro', description: 'Automated 3 banking workflows', image: '💳', points: 300 } ],
  locked: []
};

export const MOCK_VERIFIED_TASKS = { verified: [], pendingVerification: [] };
